import './shortcut';
import './permissions';
import './uploader';
import './modal';
import './sortable';